export default function* removeConnectorSaga(getFirebase, action) {
  const { payload: { projectId, connectors } } = action;
  try {
    const newConnectors = connectors.reduce((previous, key) => {
      const tmp = previous;
      tmp[key] = null;
      return tmp;
    }, {});
    yield getFirebase().update(`/projects/${projectId}/map/connectors`, newConnectors);
  } catch (err) {
    console.log('Error in saga!:', err);
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/map/RemoveConnectorSaga.js